export const PRESET_QUESTIONS = [
    'What is your favorite hobby?',
    'What is your dream job?',
    'What is your favorite book?',
    'What is your favorite movie?',
    'What is your favorite travel destination?',
] as Array<string>;

export const LONG_LIMIT = 50 as number;
export const SHORT_LIMIT = 20 as number;

export const HR_FIELDS = [
    'Compensation',
    'Health and Safety',
    'HR Business and Strategy',
    'HR Information Systems',
    'Labour Relations',
    'Organizational Development',
    'Performance Management',
    'Recruitment and Selection',
    'Training and Development'
] as Array<string>;

export const INDUSTRY = [
    'Agriculture, forestry, fishing, and hunting', 
    'Mining, quarrying, and oil and gas extraction', 
    'Utilities', 
    'Construction', 
    'Manufacturing', 
    'Wholesale trade', 
    'Retail trade', 
    'Transportation and warehousing', 
    'Information and cultural industries', 
    'Finance and insurance', 
    'Real estate and rental and leasing', 
    'Professional, scientific, and technical services', 
    'Management of companies and enterprises', 
    'Administrative and support, waste management, and remediation services', 
    'Educational services', 
    'Healthcare and social assistance', 
    'Arts, entertainment, and recreation', 
    'Accommodation and food services', 
    'Other services, excluding public administration', 
    'Public administration'
] as Array<string>;